import LoadingButton from '@atlaskit/button/loading-button';
import Button from '@atlaskit/button/standard-button';
import { useFlags } from '@atlaskit/flag';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { getFlagForError, getFlagForSuccess } from '@atlassian/developer-space';
import { archivePartner } from '@atlassian/mpac-api-client';
import { showModalIfTwoSVSessionExpires, useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import { archivePartnerLink, log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ArchivePartnerButtonStyle = {
  lineHeight: '40px',
  height: '40px',
  marginLeft: '10px'
};
const ArchivePartner = props => {
  const {
    showFlag
  } = useFlags();
  const [isArchivePartnerModalOpen, setArchivePartnerModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  const handleOpenModal = () => setArchivePartnerModalOpen(true);
  const handleCloseModal = () => setArchivePartnerModalOpen(false);
  const handleArchivePartner = async () => {
    setIsLoading(true);
    try {
      await archivePartner(props.mpacBaseUrl, props.partnerId);
      showFlag(getFlagForSuccess('archive-partner-success-flag', 'Vendor is archived successfully'));
      handleCloseModal();
      window.location.href = archivePartnerLink().expand({
        partnerId: props.partnerId
      });
    } catch (error) {
      showModalIfTwoSVSessionExpires(error, setTwoStepAuthTimedOut);
      showFlag(getFlagForError('archive-partner-failure-flag', 'Archiving this vendor failed'));
      log.error('PartnerActions/ArchivePartner', "Failed to archive partner", {
        error
      });
    }
    setIsLoading(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      style: ArchivePartnerButtonStyle,
      onClick: handleOpenModal,
      children: "Archive vendor"
    }), isArchivePartnerModalOpen && /*#__PURE__*/_jsxs(ModalDialog, {
      onClose: handleCloseModal,
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        children: /*#__PURE__*/_jsx(ModalTitle, {
          children: "Archive vendor"
        })
      }), /*#__PURE__*/_jsxs(ModalBody, {
        children: ["This will archive all of ", props.partnerName, "'s apps. Are you sure?"]
      }), /*#__PURE__*/_jsxs(ModalFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          appearance: "subtle",
          isLoading: isLoading,
          onClick: handleArchivePartner,
          children: "Ok"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleCloseModal,
          children: "Cancel"
        })]
      })]
    })]
  });
};
export default ArchivePartner;